export default __webpack_public_path__ + "static/media/sports (10).c7a640b9.jpg";